import { createSelector } from "reselect";
const selector = (state) => state.groups;

export default createSelector([selector], (data) => data);